// @ts-nocheck
import React, { useRef, useEffect, useState, useCallback, lazy, Suspense } from "react";
// import styles from "./index.module.less";
import ScrollView from "@/baseComponents/ScrollView";
// import { mountDesignerPreview } from "@jd/workplace-designer-inner";
import { getWorkbenchDetailInfo } from "@/api/workbench";
import { layoutTemplate } from "./mock";
import * as antd from "antd";
// import adaptorFactory from "@jd/react-adaptor-inner";
import { message } from "antd";
import adaptorFactory from "@jd/react-adaptor-inner";
import cardTemplateService from "./CardTemplateService";
import cardRequestService from "./CardRequestService";
import Bus from "@/utils/bus";
// import VisibilitySensor from "react-visibility-sensor";
import { connect } from "dva";
import { Dayjs } from "dayjs";
import {
  formatCardDate,
  formatCardWeekDate
} from "@/components/Calendars/utils/workbencheCalendarCard";
import { getTypeImage } from "@/components/Calendars/utils/getTypeImage";
import { getWeekList, formatScheduleTime } from "@/components/Calendars/utils";
import { getScheduleListByDateRange } from "@/api/calendar";
import IconFont from "@/components/icon";
import EmptyImg from "@/assets/img/thirdApp/card-empty.png";
import styles from "./index.module.less";
import { FocusSDK, isFocusEnv } from "@/utils";
import { changeEgovUrl } from "@/utils/tools";
import { PRIORITY_TYPE_MAP } from "@/components/Projects/emnu";
import { ThirdAppContext } from "@/components/ThirdApp/utils";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import DropdownSort from "../RightContent/DropdownSort";
import { ScheduleDetailFrom } from "@/components/Calendars/Schedule/Detail";
import moment from "moment";
import { v4 } from "uuid";
import { analysisLog } from "@/utils/logAnalytics";

const script = document.createElement("script");
const localScript = document.createElement("script");
const VisibilitySensor = lazy(() => import("react-visibility-sensor"));
interface RequestParams {
  cardId: string;
  appKey: string;
  interfaceUrl: string;
  isSystem?: boolean;
}

interface RequestScheduleOpts {
  beginDate: number;
  endDate: number;
}

const tabKeyEnum = {
  backLog: "待办事项",
  task: "任务",
  schedule: "日程"
};

function ThirdApplications (props: any) {
  const {
    openCreateModal,
    changeViewTab,
    setIsLoadJs,
    isLoadJs,
    currentSelectedWorkbench,
    onManageFavoriteApp,
    changeScheduleInfoDraw,
    changePersonalTaskDraw
  } = props;
  const { favoriteSortType, onChangeFavoriteSortType } = React.useContext(ThirdAppContext);
  const divRef = useRef<HTMLDivElement | null>(null);
  const tab = useRef<string>();
  const value = useRef();
  const [layoutValue, setLayoutValue] = useState<any>({});
  const layoutCards = useRef<any>();
  const mountDesignerRef = useRef<any>();
  const { t } = useTranslation("calendar");
  const history = useHistory();
  let localTemplateLoadedFlag = false;

  function openSetting (cardLayoutId?: string) {
    onManageFavoriteApp?.(cardLayoutId);
  }
  const onTabChane = useCallback(
    (id: string) => {
      tab.current = id;
      const index = layoutValue["tabs"].findIndex((t: any) => t.id === id);
      value.current = layoutValue["tabs"][index]["layouts"];
      renderDesignerPreview(layoutValue);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [layoutValue]
  );
  // 公共的方法
  cardTemplateService.addService("bodyHeader", {
    tabChange: onTabChane
  });

  cardTemplateService.addService("eventBus", {
    getBus: () => Bus
  });

  cardTemplateService.addService("emptyImg", {
    getEmptyImg: () => {
      return EmptyImg;
    }
  });

  cardTemplateService.addService<RequestScheduleOpts, Promise<any[]>>("calendar", {
    getScheduleListByDateRange: (opts) => {
      return getScheduleListByDateRange(opts);
    }
  });

  cardTemplateService.addService<Dayjs, string>("calendar", {
    formatCardDate: (date) => {
      return formatCardDate(date);
    },
    formatCardWeekDate: (date) => {
      return formatCardWeekDate(date);
    }
  });

  cardTemplateService.addService<Dayjs, Dayjs[]>("calendar", {
    getWeekList: (date) => {
      return getWeekList(date);
    }
  });

  cardTemplateService.addService("calendar", {
    createSchedule: () => {
      openCreateModal({
        visible: true,
        quickCreate: false,
        title: "",
        createModalFrom: 2
      });
    },
    changeScheduleInfoDraw: (item) => {
      changeScheduleInfoDraw({
        visible: true,
        scheduleId: item.id,
        selectedScheduleTime: moment(item.beginTime), // 选中的时间
        from: ScheduleDetailFrom.Workbench,
        openTime: moment(),
        isBusy: item.isBusy,
        beginTime: item.beginTime,
        endTime: item.endTime
      });
    },
    weeksSchedule: () => {
      changeViewTab("week");
      Bus.emit("nav:calendar-nav-click");
    },
    getBus: () => {
      return Bus;
    }
  });
  cardTemplateService.addService("task", {
    changePersonalTaskDraw: (item) => {
      changePersonalTaskDraw(item.taskId);
    }
  });
  cardTemplateService.addService<string, string>("calendar", {
    getTypeImage: (color) => {
      return getTypeImage(color);
    },
    getEmptyImg: () => {
      return EmptyImg;
    }
  });

  const isPrivateNet = FocusSDK.isPrivateNet();

  cardTemplateService.addService<{} & RequestParams, null | Promise<any>>("thirdApp", {
    isPrivateNet,
    openUrl: (params: any) => {
      const urlObj = JSON.parse(params.topLink);
      const data = {
        openUrl: isFocusEnv ? urlObj.url.pc : urlObj.url.web,
        appKey: params.relatedApplication.applicationKey,
        openApiType: params.openable === 0 ? 1 : 2
      };
      console.log(333, data);
      Bus.emit("openThirdAppByWorkPlateCard", data);
    },
    openItem: (params: any, isOpenInsideRoute?: boolean) => {
      if (isOpenInsideRoute) {
        Bus.emit("openInsideRouteByWorkPlateCard", params);
        history.push(params.openUrl);
      } else {
        Bus.emit("openThirdAppByWorkPlateCard", params);
      }
    },
    onRequest: (params: RequestParams, extendParams?: any) => {
      console.log("卡片数据请求发送中", params, extendParams);
      return new Promise((resolve, reject) => {
        cardRequestService.addRequest({ ...params, extendParams, resolve, reject });
      });
    },
    getEmptyImg: () => {
      return EmptyImg;
    },
    onImmedRequest: (params: RequestParams, extendParams?: any) => {
      return cardRequestService.baseRequest({ ...params, extendParams });
    },
    getManageFavoriteApp: (cardLayoutId?: string) => {
      return (
        <div
          className={styles["label"]}
          onClick={() => {
            cardLayoutId ? openSetting(cardLayoutId) : openSetting();
          }}
        >
          <IconFont type="iconic_app_set" style={{ fontSize: "16px", color: "#62656D" }} />
          <span className={styles["text"]}>管理应用</span>
        </div>
      );
    },
    getSortApp: (style, favoriteSortType) => {
      return (
        <DropdownSort
          coustomStyle={style}
          favoriteSortType={favoriteSortType}
          onChangeFavoriteSortType={onChangeFavoriteSortType}
          isCard={true}
        />
      );
    },
    analysisLog: (log_type1: string, log_type2: string, params: any) => {
      analysisLog(
        log_type1,
        log_type2,
        currentSelectedWorkbench.workBenchId,
        currentSelectedWorkbench.workBenchName,
        JSON.stringify(params)
      );
    }
  });

  cardTemplateService.addService<{} & RequestParams, null | Promise<any>>("todoTaskScheduleList", {
    onRequest: (params: RequestParams, extendParams?: any) => {
      console.log("卡片数据请求发送中", params, extendParams);
      return new Promise((resolve, reject) => {
        cardRequestService.addRequest({ ...params, extendParams, resolve, reject });
      }).then((res: any) => {
        let dataList = [];
        for (let key in res) {
          if (res.hasOwnProperty(key) && res[key]) {
            let tabsListItem = handleData(res, key);
            dataList.push(tabsListItem);
          }
        }
        return { content: dataList, originData: res };
      });
    }
  });
  const getScheduleTaskIcon = (key, value) => {
    if (key === "task") {
      let iconUrl = changeEgovUrl(PRIORITY_TYPE_MAP[value]?.url);
      return iconUrl;
    }
    if (key === "schedule") {
      let iconUrl = getTypeImage(value);
      return iconUrl;
    }
  };

  const handleData = (res: any, key: string) => {
    let dataList = res[key]?.records || [];
    let tabsListItem = {
      tabKey: key,
      tabName: tabKeyEnum[key],
      moreName: `全部${tabKeyEnum[key]}`,
      total: res[key].total,
      descUrl: res[key].descUrl,
      descUrlEgov: res[key].descUrlEgov,
      dataList: dataList.map((item: any) => {
        let dateRange = "";
        let iconUrl = "";
        let dutyName = "";
        if (key === "task") {
          dutyName = item.owner?.realName || "";
          iconUrl = getScheduleTaskIcon("task", item.priorityType);
        }
        if (key === "schedule") {
          dateRange = formatScheduleTime(item.beginTime, item.endTime, item.isAlldate || 0, t);
          iconUrl = getScheduleTaskIcon("schedule", item.color);
        }
        return {
          title: item.itemName || item.content || item.title,
          additional:
            key === "backLog"
              ? moment(item.submitTime).format("YYYY-MM-DD")
              : key === "task"
              ? dutyName
              : dateRange,
          iconUrl,
          ...item
        };
      })
    };
    return tabsListItem;
  };

  const dealRemoteCardTmpl = (resolve, reject) => {
    localScript.src = `${process.env.PUBLIC_URL}/cardTemplate.min.js?random=${v4()}`;
    document.body.appendChild(localScript);
    localScript.onload = () => {
      localTemplateLoadedFlag = true;
      resolve({});
    };
    localScript.onerror = (errInfo) => {
      FocusSDK.printLog(errInfo?.message || "load local cardTemplate Error");
      reject(errInfo);
    };
  };

  const getLastTemplateJs = function () {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        dealRemoteCardTmpl(resolve, reject);
      }, 2000);
      window.React = React;
      (window as any).antd = antd;
      script.type = "text/javascript";
      // script.src = `${process.env.PUBLIC_URL}/cardTemplate.min.js?random=${v4()}`;
      script.src = changeEgovUrl(
        `https://jzb.beijing.gov.cn/oss/focus-desktop/workPlat/customTemplate/cardTemplate.min.js?random=${v4()}`
      );
      document.body.appendChild(script);
      script.onload = () => {
        clearTimeout(timer);
        resolve({});
      };
      script.onerror = (errInfo) => {
        clearTimeout(timer);
        if (!localTemplateLoadedFlag) {
          dealRemoteCardTmpl(resolve, reject);
        }
        FocusSDK.printLog(errInfo?.message || "load remote cardTemplate Error");
        // reject(errInfo);
      };
    });
  };

  const getWorkbenchDetail = () => {
    return getWorkbenchDetailInfo({
      workBenchId: currentSelectedWorkbench.workBenchId
    });
  };

  // 卡片进入视口
  const visibilityOnChange = useCallback(({ isVisibility, params }: any) => {
    if (isVisibility) {
      cardRequestService.getCardData(params.layoutId);
    }
  }, []);

  function GetCardTemplate (Com: any, params: any) {
    return function (props: any) {
      return (
        <Suspense fallback={<div>Loading...</div>}>
          <VisibilitySensor
            partialVisibility
            onChange={(isVisibility) => {
              Bus.emit("visibilityOnChange", { isVisibility, params });
            }}
            delayedCall
          >
            <Com {...props} />
          </VisibilitySensor>
        </Suspense>
      );
    };
  }

  const renderDesignerPreview = async (layoutValue: any) => {
    const cards = layoutCards.current;
    if (mountDesignerRef.current?.destory) {
      mountDesignerRef.current?.destory();
    }
    window.__isReactDndBackendSetUp = false;
    // const widget = await import("./widget");
    const { mountDesignerPreview } = await import("@jd/workplace-designer-inner");
    const { default: adaptorFactory } = await import("@jd/react-adaptor-inner");
    const adaptor = adaptorFactory(cardTemplateService.services);

    mountDesignerRef.current = mountDesignerPreview(divRef.current as HTMLElement, {
      layoutTemplate,
      value: value.current,
      onChange: () => { },
      defaultTheme: {},
      onRenderWidget: (item: any) => {
        const card = cards[item.cardId];
        if (!card) {
          return;
        }
        card.layoutId = item.id;
        const Widget = (window as any).cardTemplate[card.relatedComponent];
        const CurWidget = adaptor(GetCardTemplate(Widget, card));
        if (card.visible) {
          return Widget ? (
            <CurWidget favoriteSortType={favoriteSortType} item={card} {...item} isPreview={true} />
          ) : (
            <div>widget</div>
          );
        } else {
          let isNativeHead = item.isNativeHead;
          let maxHeight = isNativeHead ? 172 : 218;
          return (
            <div className={styles.empty_wrap}>
              <div className={styles.empty_box}>
                {item.layout.contentHeight > maxHeight && <img src={EmptyImg} alt="暂无数据" />}
                <p>{card.reason || "暂无数据"}</p>
              </div>
            </div>
          );
        }
      },
      onWidgetListLoad: () => [],
      onBeforeUpload: () => { },
      onRenderBodyHeader: () => {
        const BodyHeader = (window as any).cardTemplate["BodyHeader"];
        const CurBodyHeader = adaptor(BodyHeader);
        return (
          <CurBodyHeader
            title="工作台"
            currentTab={tab.current}
            tabs={layoutValue.tabs || []}
            isPreview={true}
          />
        );
      }
    });
  };

  const handleWorkbenchDetail = (workbenchDetail: any) => {
    const { content, cards } = workbenchDetail;
    layoutCards.current = cards;
    let layoutValue = JSON.parse(content);
    setLayoutValue(layoutValue);
    tab.current = layoutValue.tabs[0].id;
    value.current = layoutValue["tabs"][0]["layouts"];
    renderDesignerPreview(layoutValue);
  };

  useEffect(() => {
    // cardTemplate.js文件加载完成，不再重新加载；
    if (!divRef.current || isLoadJs) {
      return;
    }
    Promise.all([getLastTemplateJs(), getWorkbenchDetail()])
      .then((res: any) => {
        const detail = res[1];
        const { workbenchDetailDto } = detail || {};
        if (workbenchDetailDto) {
          handleWorkbenchDetail(workbenchDetailDto);
        }
        setIsLoadJs({ isLoadJs: true });
      })
      .catch((error) => {
        const msg = error?.message || "加载定制工作台失败";
        message.error(msg);
        FocusSDK.printLog(msg);
      });
    return () => {
      script.onload = null;
      if (mountDesignerRef.current?.destory) {
        mountDesignerRef.current?.destory();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentSelectedWorkbench.workBenchType === 1 && isLoadJs) {
      getWorkbenchDetail()
        .then((res: any) => {
          const { workbenchDetailDto } = res || {};
          handleWorkbenchDetail(workbenchDetailDto);
          cardRequestService.clearRequest();
        })
        .catch((e) => {
          const msg = e?.message || "切换工作台失败";
          message.error(msg);
          FocusSDK.printLog(msg);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSelectedWorkbench]);

  useEffect(() => {
    Bus.on("visibilityOnChange", visibilityOnChange);
    return () => {
      Bus.off("visibilityOnChange", visibilityOnChange);
    };
  }, [visibilityOnChange]);

  return (
    <ScrollView style={{ height: "calc(100vh - 132px)" }}>
      <div style={{ height: "100%" }} ref={divRef} />
    </ScrollView>
  );
}
function mapStateToProps ({ workbench, calendar }: any) {
  const { cardAccessTokenList, currentSelectedWorkbench, workbenchDetail, isLoadJs } = workbench;
  return {
    cardAccessTokenList,
    currentSelectedWorkbench,
    workbenchDetail,
    isLoadJs // ,
    // otherUser: calendar.otherUser
  };
}

function mapDispatchToProps (dispatch: any) {
  return {
    setCardAccessTokenList: (payload: any) => {
      dispatch({ type: "workbench/setCardAccessTokenList", payload });
    },
    setWorkbenchDetail: (payload: any) => {
      dispatch({ type: "workbench/setWorkbenchDetail", payload });
    },
    setIsLoadJs: (payload: any) => {
      dispatch({ type: "workbench/setIsLoadJs", payload });
    },
    openCreateModal (data: any) {
      dispatch({
        type: "calendar/openCreateModal",
        payload: data
      });
    },
    changeScheduleInfoDraw (data: any) {
      dispatch({
        type: "calendar/changeScheduleInfoDraw",
        payload: data
      });
    },
    changePersonalTaskDraw (taskId: string, activeTab?: string) {
      return dispatch({
        type: "work/changePersonalTaskDraw",
        payload: { taskId, drawVisible: true, activeTab, chat: true }
      });
    },
    changeViewTab (viewTab: string) {
      dispatch({ type: "calendar/changeViewTab", payload: { viewTab } });
    },
    getWorkbenchDetailInfo (payload: any) {
      dispatch({ type: "workbench/getWorkbenchDetailInfo", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ThirdApplications);
